import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { EditorNavigatorService } from '../../features/editor-navigator-page/@core/services/editor-navigator.service';
import { UnsavedChangesModalService } from '../../shared/services/unsaved-changes-modal.service';

export interface IHasUnsavedChanges {
  hasUnsavedChanges(): boolean;
  saveDraft(): Promise<boolean>;
}

@Injectable({ providedIn: 'root' })
export class UnsavedChangesGuard implements CanDeactivate<IHasUnsavedChanges> {
  private readonly _editorNavigatorService = inject(EditorNavigatorService);
  private readonly _unsavedChangesModalService = inject(UnsavedChangesModalService);

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this._editorNavigatorService.hasUnsavedChanges() || this._editorNavigatorService.forcedUnsavedChanges) return true;

    const userDecisionPromise: Promise<boolean> = this._unsavedChangesModalService.show();

    return userDecisionPromise.then((canNavigate): boolean => {
      return canNavigate;
    });
  }
}
